module.exports = __webpack_public_path__ + "img/events-active.5701ff4b.svg";